<mat-card>
  <mat-card-header>
    <mat-card-title>Dokumentversion (read-only)</mat-card-title>
    @if(version) {
      <mat-card-subtitle>
        Gültig ab: {{ version.getCreatedAt() | date: 'dd.MM.yyyy, HH:mm' }} · Benutzer-ID: {{ version.getCreatedByUserId() }}
      </mat-card-subtitle>
    }
  </mat-card-header>
  <mat-card-content>
    <p *ngIf="loading" class="loading">
      <mat-spinner diameter="32"></mat-spinner>
      Version wird geladen…
    </p>
    <p *ngIf="error" class="error">{{ error }}</p>
    <div class="actions">
      <button mat-raised-button (click)="back()">Zurück zur Versionshistorie</button>
    </div>
    <div *ngIf="!loading && !error && safeContent" class="version-content" [innerHTML]="safeContent"></div>
  </mat-card-content>
</mat-card>
